import { fetchApi } from '@/config/axiosSetting';

import { GetBodyAdjusterImagesQueryResponseType } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyAdjusterImages/getBodyAdjusterImagesQuery.type';
import { GetBodyAdjusterImagesQueryParamsType } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyDamagedAdjusterImages/getBodyDamagedAdjusterImagesQuery.type';

export const getBodyAdjusterImagesFunction = (
  params: GetBodyAdjusterImagesQueryParamsType,
): Promise<GetBodyAdjusterImagesQueryResponseType> => {
  return fetchApi.get(`body/reports/${params?.id}/images/adjuster/vehicle/`, {
    params,
  });
};
